// extracted by mini-css-extract-plugin
module.exports = {"PDFDownloader":"PDFDownloader_PDFDownloader__2HQDA","pdfContainer":"PDFDownloader_pdfContainer__31Umw","button":"PDFDownloader_button__1YLgR"};